import { Box, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { GREEN_COLOR, ORANGE_COLOR } from '../../../constants';
import { NumberLetterObj } from './PinCodeGame';

interface KeyboardCharProps {
  numberLetter: NumberLetterObj;
  onClick: (value: string) => void;
}

const KeyboardChar: FC<KeyboardCharProps> = ({ numberLetter, onClick }) => {
  const theme = useTheme();

  let bgColor = '';

  switch (numberLetter.correctPosition) {
    case 1:
      bgColor = ORANGE_COLOR;
      break;
    case 2:
      bgColor = GREEN_COLOR;
      break;
    case 3:
      bgColor = theme.palette.card?.main || 'red';
      break;
    default:
      break;
  }

  const styles = {
    container: {
      height: 50,
      width: 50,
      borderRadius: 2,
      // boxShadow: `${theme.palette.boxBorder?.main} 2px 2px 2px 1px`,
      color: theme.palette.text.primary,
      backgroundColor: bgColor,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&:hover': {
        borderColor: theme.palette.primary.main,
        // boxShadow: `${theme.palette.boxBorder?.dark} 2px 2px 2px 1px`,
      },
    },
  };

  const getTypographyVariant = () => {
    return ['Del', 'Ent'].includes(numberLetter.number) ? 'h6' : 'h5';
  };

  return (
    <Box sx={styles.container} onClick={() => onClick(numberLetter.number)}>
      <Typography variant={getTypographyVariant()}>
        {numberLetter.number}
      </Typography>
    </Box>
  );
};

export default KeyboardChar;
